import {
	ADD_MENU_ENTRY_TO_CART,
	CHANGE_ORDER_LINE_MODIFIERS,
	DEC_ORDER_LINE_QUANTITY,
	INC_ORDER_LINE_QUANTITY,
} from 'new-constants/order-line.constants';
import {OrderLineActionTypes} from './order-line.actions.types';
import {RestaurantId} from '../helpers/restaurant.helper.types';
import {OrderLineToken} from '../helpers/order-line.helper.types';
import {MenuEntryModifierSelections, ModifierGroupId} from '../helpers/modifier.helper.types';
import {MenuEntryId} from '../helpers/menu.helper.types';
import {PopupId} from './popup.actions.types';
import {trackEvent} from "../helpers/tracking.helpers";

export const addMenuEntryToCart = (
	restaurantId: RestaurantId,
	menuEntryId: MenuEntryId,
	quantity: number,
	modifierSelections: MenuEntryModifierSelections,
	blockingPopup: PopupId,
	postponingPopup: PopupId,
	modifierValidationErrors: string,
    isDefaultTakeAwayItem: boolean = false,
): OrderLineActionTypes => {
	trackEvent({
		event: 'Add Item To Cart',
		properties:
			{
				'Venue Id': restaurantId,
				'Item Id': menuEntryId,
			}
	});
	return {
		type: ADD_MENU_ENTRY_TO_CART,
		showPopup: blockingPopup || postponingPopup,
		isAddToCart: !blockingPopup && !postponingPopup,
		isTemporarySave: !blockingPopup && !!postponingPopup,
		restaurantId,
		menuEntryId,
		quantity,
		modifierSelections,
		modifierValidationErrors,
        isDefaultTakeAwayItem
	};
};

export const incOrderLineQuantity = (restaurantId: RestaurantId, token: OrderLineToken): OrderLineActionTypes => {
	return {
		type: INC_ORDER_LINE_QUANTITY,
		restaurantId,
		token,
	};
};

export const decOrderLineQuantity = (restaurantId: RestaurantId, token: OrderLineToken): OrderLineActionTypes => {
	return {
		type: DEC_ORDER_LINE_QUANTITY,
		restaurantId,
		token,
	};
};

export const changeOrderLineModifiers = (restaurantId: RestaurantId,
																				 token: OrderLineToken,
																				 modifierGroupId: ModifierGroupId,
																				 modifierSelections: MenuEntryModifierSelections): OrderLineActionTypes => {
	return {
		type: CHANGE_ORDER_LINE_MODIFIERS,
		restaurantId,
		token,
		modifierGroupId,
		modifierSelections,
	};
};
